import { Injectable } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class AppRouterService {
    private previousUrl: string = '';
    private queryParams!: Params;

    constructor(private router: Router, private route: ActivatedRoute) {}

    getPreviousRoute(): { url: string; queryParams: Params } {
        return { url: this.previousUrl, queryParams: this.queryParams };
    }

    logPreviousUrl() {
        const currentUrl = this.router.url.indexOf('?') > -1 ? this.router.url.split('?')[0] : this.router.url;
        const currentQueryParams = this.route.snapshot.queryParams;
        this.setPreviousRoute(currentUrl, currentQueryParams);
    }

    private setPreviousRoute(previousUrl: string, queryParams: Params = {}) {
        this.previousUrl = previousUrl;
        this.queryParams = queryParams;
    }
}
